// ----------------------------------------------------------------------

const ROOTS = {
  DASHBOARD: '/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  home: '/home',
  gates: '/dataLagoon',
  api: '/api',
  mathMatrix: {
    overview: '/mathMatrix/overview',
    dashboard: '/mathMatrix/dashboard',
  },
  // minimalUI: 'https://mui.com/store/items/minimal-dashboard/',

  datasets: '/datasets',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  support: '/support',
  users: '/users',
  user: (id: string) => `/users/${id}`,
  profile: '/profile',
  loghistory: '/loghistory',
  pendingApproval: '/pending-approval',
  docs: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
  zoneUI: 'https://mui.com/store/items/zone-landing-page/',
  freeUI: 'https://mui.com/store/items/minimal-dashboard-free/',
  figma:
    'https://www.figma.com/file/kAYnYYdib0aQPNKZpgJT6J/%5BPreview%5D-Minimal-Web.v5.0.0?type=design&node-id=0%3A1&t=Al4jScQq97Aly0Mn-1',
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    one: `${ROOTS.DASHBOARD}/one`,
    two: `${ROOTS.DASHBOARD}/two`,
    three: `${ROOTS.DASHBOARD}/three`,
    group: {
      root: `${ROOTS.DASHBOARD}/group`,
      five: `${ROOTS.DASHBOARD}/group/five`,
      six: `${ROOTS.DASHBOARD}/group/six`,
    },
    support: '/support',
    login: '/login',
    signUp: '/sign-up',

    assignAccess: '/assign-access',
    logHistory: '/log-history',
  },
  nwrDashboard: '/nwrDashboard',
  newWorldsReading: '/newWorldsReading',
};
